export const defaultStyle = {
	align: "center",
	backgroundColor: "",
	backgroundImage: "",
	backgroundPosition: "center center",
	backgroundRepeat: "no-repeat",
	backgroundSize: "auto",
	borderBottomColor: "#121212",
	borderBottomStyle: "solid",
	borderBottomWidth: "0px",
	borderLeftColor: "#121212",
	borderLeftStyle: "solid",
	borderLeftWidth: "0px",
	borderRadius: "0px",
	borderRightColor: "#121212",
	borderRightStyle: "solid",
	borderRightWidth: "0px",
	borderTopColor: "#121212",
	borderTopStyle: "solid",
	borderTopWidth: "0px",
	fullWidthOnMobile: false,
	lockedHeight: null,
	lockedWidth: null,
	marginBottom: "0px",
	marginLeft: "0px",
	marginRight: "0px",
	marginTop: "0px",
	maxHeight: "300px",
	maxWidth: "300px",
	paddingBottom: "0px",
	paddingLeft: "0px",
	paddingRight: "0px",
	paddingTop: "0px",
	width: "150px",
};

export const defaultAttrs = {
	altText: "",
	link: "",
	src: "https://cdn.chamaileon.io/assets/img/image_placeholder.png",
	title: "",
};
